import React from 'react';
import { EventList } from './LandingPage/EventList.js';
export const ContactInfoEvents = (props) => {
    const { events, language } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement("h2", null, "Tapahtumat"),
        React.createElement(EventList, { events: events !== null && events !== void 0 ? events : [], language: language })));
};
